

























import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class Diff extends Vue {
  @Prop({ default: "" })
  private name!: string
  @Prop({ default: "" })
  private before!: string
  @Prop({ default: "" })
  private after!: string
  @Prop({ default: "" })
  private diff!: string
}
